module.exports = __webpack_public_path__ + "img/mardelplata_generica.26f9aabb.svg";